<template>
	<div>
		<v-combobox
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			class="chiped-input"
			:rules="rules"
			@update:error="errored = $event"
			:value="value"
			clearable
			chips
			:small-chips="dense"
			:name="param.name"
			:deletable-chips="!readonly"
			:items="[]"
			:multiple="multiple"
			:readonly="readonly"
			append-icon="folder_open"
			@click:append="showFileExplorer(param)"
			@change="onChange($event)">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>

			<template v-slot:selection="{ item, index }">
				<v-tooltip bottom content-class="background" :nudge-top="8">
					<template v-slot:activator="{ on }">
						<v-chip v-on="on" label :close="!readonly" @input="remove(index)" class="path-chip">
							{{ getPathBasename(item) }}
						</v-chip>
					</template>
					<span>{{ item }}</span>
				</v-tooltip>
			</template>
		</v-combobox>

		<Hint :param="param" :errored="errored"></Hint>

		<FileExplorer
			v-if="file_explorer.visible"
			:multiselect="file_explorer.multiple"
			:default_folder="file_explorer.default_value"
			:toolbarTitle="file_explorer.destination_key"
			:assetType="file_explorer.assetType"
			@close="file_explorer.visible = false; file_explorer.destination_key = null"
			@selectedAssets="onfileSelected">
			<h3 slot="header">Asset Select for Maestro ingester</h3>
		</FileExplorer>
	</div>
</template>

<script>
import Path from 'path'
import Label from '@/components/fields/label.vue'
import FileExplorer from '@/components/modal_explorer.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		FileExplorer,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false,
			file_explorer: {
				visible: false,
				destination_key: null,
				assetType: 'file',
				default_value: null,
				multiple: false
			}
		}
	},
	computed: {
		multiple () {
			if (!this.param) return false
			return this.param.type.indexOf('multi-') === 0
		}
	},
	methods: {
		remove (index) {
			if (this.multiple) {
				this.value.splice(index, 1)
			} else {
				this.$emit('update:value', '')
			}
		},
		onChange (value) {
			const clean = (val) => {
				if (val[0] === '"') val = val.slice(1)
				if (val[val.length - 1] === '"') val = val.slice(0, val.length - 1)
				return val.replaceAll(/\\/g, '/')
			}
			if (this.multiple) {
				if (value.length > 0) {
					value[value.length - 1] = clean(value[value.length - 1])
				}
				this.$emit('update:value', value)
			} else {
				this.$emit('update:value', clean(value))
			}
		},
		getPathBasename (path) {
			try {
				return Path.basename(path) || ''
			} catch (error) {
				return ''
			}
		},
		onfileSelected (evt) {
			if (Array.isArray(evt)) {
				let selectedPaths = evt.map(item => {
					let maestroPath = this.$paths.UNCToMaestro(item.path)
					if (item.type === 'folder') maestroPath += '/'
					return maestroPath
				})
				for (const item of this.value) {
					if (selectedPaths.indexOf(item) === -1) selectedPaths.push(item)
				}
				this.$emit('update:value', selectedPaths)
			} else {
				let maestroPath = this.$paths.UNCToMaestro(evt.path)
				if (evt.type === 'folder') {
					this.$emit('update:value', maestroPath + '/')
				} else {
					this.$emit('update:value', maestroPath)
				}
			}
		},
		showFileExplorer (param) {
			if (this.readonly) return
			this.file_explorer.multiple = param.type.indexOf('multi-') === 0
			if (param.type === 'directory' || param.type === 'multi-directory') {
				this.file_explorer.assetType = 'folder'
			} else if (param.type === 'file' || param.type === 'multi-file') {
				this.file_explorer.assetType = 'file'
			} else {
				this.file_explorer.assetType = null
			}
			this.file_explorer.destination_key = param.name
			this.file_explorer.default_value = null
			if (param.default) {
				this.file_explorer.default_value = this.$paths.maestroToUNC(param.default)
			}
			this.file_explorer.visible = true
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			if (Array.isArray(value)) {
				if (value.length === 0) return 'Requis'
			}
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/filesystem_path_file_folder.vue